import { useContext, useEffect } from 'react';
import { ScreenshotDataContext } from '@mentimeter/screenshots/ScreenshotDataContext';

export function useScreenshotReady({ isReady }: { isReady: boolean }) {
  const { setSlideIsReady } = useContext(ScreenshotDataContext);

  useEffect(() => {
    setSlideIsReady(isReady);
  }, [isReady, setSlideIsReady]);
}
